<template>
  <div class="banner-module">
    <el-row
      :gutter="10"
    >
      <el-col :span="18">
         <div
           class="big-image"
           :style="{backgroundImage: `url(${moduleInfo.bigImgUrl})`}"
         >
         </div>
      </el-col>
      <el-col :span="6">
        <div
          class="tom-img top"
          :style="{backgroundImage: `url(${moduleInfo.rightTopImgUrl})`}"
        >
        </div>
        <div
          class="tom-img"
          :style="{backgroundImage: `url(${moduleInfo.rightBottomImgUrl})`}"
        >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "bannerModule",
  props: {
    moduleInfo: {
      type: Object,
      default(){
        return {
          bigImgUrl: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Flmg.jj20.com%2Fup%2Fallimg%2F1114%2F041621122252%2F210416122252-1-1200.jpg&refer=http%3A%2F%2Flmg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1671847882&t=0129ba426cc26249b5fd5bff2545d320',
          rightTopImgUrl: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.daimg.com%2Fuploads%2Fallimg%2F210114%2F1-210114151951.jpg&refer=http%3A%2F%2Fimg.daimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1671847882&t=4a7256ebd072ebe478dbd4e9dab010d9',
          rightBottomImgUrl: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fupload.pig66.com%2Fuploadfile%2F2017%2F0511%2F20170511075802322.jpg&refer=http%3A%2F%2Fupload.pig66.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1671847882&t=4752d26325621071e6d4b18753f14dd5',
        }
      }
    },
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.banner-module {
  .big-image {
    height: 260px;
  }
  .tom-img {
    height: 122px;
  }
  .tom-img {
    &.top {
      margin-bottom: 16px;
    }
  }
  .tom-img,
  .big-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
